/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import router from "./routes/router";
import store from "./store";
import VueCookie from "vue-cookie";

import th from "./languages/th";
import en from "./languages/en";

// Vue.prototype.getErrorText = function (data){
//   if (data.Msg == "errors.msw") {
//     return data.Cause;
//   }
//   return "";
// }
Vue.mixin({
  methods: {
    getErrorText: function(data) {
      if (data.Msg == "errors.msw") {
        return data.Cause;
      }
      return "";
    },
    getStartDate() {
      var today = new Date();
      let yy = today.getFullYear();
      let mm = today.getMonth();
      let dd = today.getDate();
      return (
        yy + "-" + (mm > 9 ? "" : "0") + mm + "-" + (dd > 9 ? "" : "0") + dd
      );
    },
    getEndDate() {
      var today = new Date();
      let yy = today.getFullYear();
      let mm = today.getMonth();
      let dd = today.getDate();
      return (
        yy +
        "-" +
        (mm + 1 > 9 ? "" : "0") +
        (mm + 1) +
        "-" +
        (dd > 9 ? "" : "0") +
        dd
      );
    },
	FormatCurrency(value) {
		if (value == null) {
			return "";
		}
		// console.log("Value : ",value);
		// console.log("Value formated: ",value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
		// format with floating point
		// return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},
  }
});

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueCookie);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "th", // set locale
  messages: { en: en, th: th } // set locale messages
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: "#app",
  render: h => h(App),
  store,
  router
});
